import React, { useState } from "react";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import ButtonNew from "../Button/Button";
import { themes } from "theme/themes";
import { brandingInfo } from "features/server/brandingSlice";
import { useSelector } from "react-redux";

interface SimpleModalProps {
  visable: boolean;
  notVisableEnternalAddBtn?: boolean;
  notVisableBackbtn?: boolean;
  padding?: boolean;
  title?: string;
  btnclosetext?: string;
  content: React.ReactNode;
  isButtonVisable?: boolean;
  isVisableBtn?: boolean;
  buttonText?: string;
  attBtnNotshow?: boolean;
  attributeChangesMessage?: string;
  showPort?: boolean;
  showPortList?: () => void;
  formSubmit?: () => void;
  showSecondaryButton?: boolean;
  secondaryButtonText?: string;
  secondaryButtonAction?: () => void;
  secondaryButtonDisabled?: boolean;
  primaryButtonType?: string;
  secondaryButtonType?: string;
  showBackButton?: boolean;
  backButtonText?: string;
  backButtonAction?: () => void;
  modalControle?: () => void;
  entityPopup?: boolean;
}

const modalCloseBtnStyle = {
  position: "absolute" as const,
  right: 15,
  top: 15,
};

const SimpleModal: React.FC<SimpleModalProps> = ({
  visable,
  notVisableEnternalAddBtn,
  notVisableBackbtn,
  padding,
  title,
  btnclosetext,
  content,
  isButtonVisable,
  isVisableBtn,
  buttonText,
  attBtnNotshow,
  attributeChangesMessage,
  showPort,
  showPortList,
  formSubmit,
  showSecondaryButton,
  secondaryButtonText,
  secondaryButtonAction,
  secondaryButtonDisabled,
  primaryButtonType,
  secondaryButtonType,
  showBackButton,
  backButtonText,
  backButtonAction,
  modalControle,
  entityPopup,
}) => {
  const [open, setOpen] = useState(visable);
  const branding = useSelector(brandingInfo);
  const themeColors =
    branding?.attributes?.themeId === 100
      ? branding?.attributes?.customTheme
      : (themes as any)[branding?.attributes?.themeId || 3];
  const handleClose = () => {
    setOpen(false);
    if (modalControle) {
      modalControle();
    }
  };

  return (
    <div style={{ display: open ? "block" : "none", width: "100%" }}>
      <Paper
        style={{
          boxShadow: "none",
          // boxShadow: notVisableEnternalAddBtn ? 'none' : undefined,
          padding: padding === false ? 0 : "20px 16px 20px 16px",
          color: "rgba(0,0,0,0.54)",
          position: "relative",
          backgroundColor: entityPopup ? "#fff" : themeColors?.appBg,
        }}
      >
        {/* {!notVisableEnternalAddBtn && title && <h1 className='mr-[5px]  ml-0 float-left font-Saira font-[700] text-[17px] text-txt-color'>{t(title)}</h1>} */}
        {!notVisableBackbtn && (
          <Button
            style={modalCloseBtnStyle}
            size="small"
            variant="outlined"
            onClick={handleClose}
          >
            {btnclosetext}
          </Button>
        )}
        <div
        //  className="mt-4"
        >
          {content}
        </div>
        {isButtonVisable && (
          <div
            className="clearfix"
            style={{
              borderTop: !notVisableEnternalAddBtn ? undefined : "2px outset",
              paddingTop: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 16,
              flexWrap: "wrap",
            }}
          >
            {attBtnNotshow ? (
              <div>
                <Button
                  variant="contained"
                  disabled={!isVisableBtn}
                  onClick={formSubmit}
                >
                  {buttonText}
                </Button>
              </div>
            ) : (
              <>
                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                  {title === "Attributes" ? null : (
                    <span>{attributeChangesMessage}</span>
                  )}
                  {showPort && (
                    <Button onClick={showPortList} style={{ marginLeft: 20 }}>
                      deviceModel
                    </Button>
                  )}
                  {showBackButton ? (
                    <ButtonNew
                      type="back"
                      text={backButtonText || "back"}
                      onClick={backButtonAction}
                    />
                  ) : null}
                </div>
                {showSecondaryButton || !notVisableEnternalAddBtn ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 16,
                      marginLeft: "auto",
                    }}
                    className="formSubmitBtn"
                  >
                    {showSecondaryButton ? (
                      <ButtonNew
                        type={
                          !secondaryButtonDisabled
                            ? secondaryButtonType || "create"
                            : "disabled"
                        }
                        disabled={secondaryButtonDisabled}
                        text={secondaryButtonText}
                        onClick={secondaryButtonAction}
                      />
                    ) : null}
                    {!notVisableEnternalAddBtn ? (
                      <ButtonNew
                        type={
                          !isVisableBtn
                            ? "disabled"
                            : primaryButtonType || "create"
                        }
                        text={buttonText}
                        disabled={!isVisableBtn}
                        onClick={formSubmit}
                      />
                    ) : null}
                  </div>
                ) : null}
              </>
            )}
          </div>
        )}
      </Paper>
    </div>
  );
};

export default SimpleModal;
